import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useFirebaseUser } from '@/hooks/useFirebaseUser'
import { GetV1WorkshopsByIdShelvesResponse } from '../client'
import {
  deleteV1WorkshopsByIdShelvesByShelfIdMutation,
  getV1WorkshopsByIdShelvesOptions,
  getV1WorkshopsByIdShelvesQueryKey,
  patchV1WorkshopsByIdShelvesByShelfIdMutation,
  postV1WorkshopsByIdShelvesMutation,
} from '../client/@tanstack/react-query.gen'
import { ExtendedQueryOptions } from '../types'

export const useShelves = (
  workshopId: string,
  options?: ExtendedQueryOptions<GetV1WorkshopsByIdShelvesResponse>,
) => {
  const { isLoggedIn } = useFirebaseUser()
  const query = useQuery({
    ...getV1WorkshopsByIdShelvesOptions({ path: { id: workshopId } }),
    enabled: isLoggedIn && !!workshopId,
    ...options,
  })

  return {
    ...query,
    data: query.data ?? [],
  }
}

export const useCreateShelf = (workshopId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...postV1WorkshopsByIdShelvesMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getV1WorkshopsByIdShelvesQueryKey({ path: { id: workshopId } }),
        exact: false,
      })
    },
  })
}

export const useUpdateShelf = (workshopId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...patchV1WorkshopsByIdShelvesByShelfIdMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getV1WorkshopsByIdShelvesQueryKey({ path: { id: workshopId } }),
        exact: false,
      })
    },
  })
}

export const useDeleteShelf = (workshopId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...deleteV1WorkshopsByIdShelvesByShelfIdMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getV1WorkshopsByIdShelvesQueryKey({ path: { id: workshopId } }),
        exact: false,
      })
    },
  })
}
